export const CommentsAnalaysisDashboardPrefix = 'comments-analysis';
export const DissatisfiedPassengerDashboardPrefix = 'dissatisfied-passenger-probe-analysis';
